<template>
  <div id="app">
    <navbar />
    <router-view />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'

export default {
  name: "App",
  components: {
    Navbar,
  },
  async created() {
    // Alert handlers
    this.$bus.$on("send-alert", $event => {
      console.log("Show alert", $event)

      const toastSettings = {
        variant: $event.variant,
        autoHideDelay: $event.variant === "success" ? 2000 : 5000,
        appendToast: true,
        solid: true,
        noCloseButton: true,
        toaster: "b-toaster-top-center",
      }

      this.$bvToast.toast($event.text, toastSettings)
    })
  },
}
</script>

<style>
  @import "~bootstrap/dist/css/bootstrap.css";
  @import "~bootstrap-vue/dist/bootstrap-vue.css";

body {
  font-family: "Helvetica Neue", -apple-system, BlinkMacSystemFont, "Segoe UI",
  Roboto, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
  "Segoe UI Symbol", "Noto Color Emoji";
}

h1 {
  font-size: 40px;
  font-weight: 500;
  color: #333333;
}

h2 {
  /*font-size: 30px;*/
  font-weight: 500;
  color: #333333;
}

h3 {
  /*font-size: 20px;*/
  font-weight: 500;
  color: #333333;
}

h4 {
  /*font-size: 16px;*/
  /*font-weight: bold;*/
  color: #333333;
}

.table th,
.table td {
  vertical-align: middle;
}

.btn-search,
.btn-search {
  color: #212529;
  background-color: #e0e0e0;
  border: solid 1px #d2d2d2;
}

.btn-search.disabled,
.btn-search:disabled {
  color: #212529;
  background-color: #f6f6f6;
  border: solid 1px #d2d2d2;
}

.btn-search.hover,
.btn-search:hover {
  background-color: #f1f1f1;
  border: solid 1px #d2d2d2;
}

.btn-bar,
.btn-bar {
  background-color: #ffffff;
  color: black;
  border: none;
}

.btn-bar.disabled,
.btn-bar:disabled {
  background-color: #ffffff;
  color: black;
  border: none;
}

.btn-bar.hover,
.btn-bar:hover,
.btn-bar:not(:disabled):not(.disabled):active,
.btn-bar:not(:disabled):not(.disabled).active,
.btn-bar:focus,
.btn-bar.focus,
.btn-bar:not(:disabled):not(.disabled):active:focus,
.btn-bar:not(:disabled):not(.disabled).active:focus {
  background-color: #f6f6f6;
  color: black;
  border: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.btn-link {
  color: #0579ff;
}

.btn-primary {
  color: white;
  background-color: #0579ff;
}

.btn-primary.hover,
.btn-primary:hover {
  color: white;
  background-color: #0062cc;
}

.btn-outline-seconday {
}

.xl-wide {
  padding: 0.2rem 2rem;
}

.form-control {
  border: solid 1px #d2d2d2;
}

.mlb-darkgrey {
  color: #666666 !important;
}

.mlb-grey {
  color: #a9a9a9 !important;
}

.mlb-black {
  color: #0e0e0e !important;
}

.clickable:hover {
  cursor: pointer;
}

.xl-wide {
  padding: 0.2rem 2rem;
}

.pointer {
  cursor: pointer;
}

.ti-tag.ti-valid {
  background-color: #999999 !important;
}

.vue-tags-input {
  max-width: none !important;
}
</style>
